import { useConfig } from '@root/Context'
import { SessionExpired } from '@root/routes/OPSM'
import { isCaOrUs } from '@root/utils/utils'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from '../Modal'
import { Typography } from '../Typography'
import {
  Divider,
  StyledBackToTheForm,
  StyledFrownIcon,
  StyledModalTitle,
  StyledNeedHelp,
  StyledSecurityInfo,
} from './ErrorModalStyles'
import { ErrorModalContentProps, ErrorModalProps } from './ErrorModalTypes'

export const ErrorModalContent: React.FC<ErrorModalContentProps> = ({
  errorMessage,
  onRequestClose,
  className,
  showBackToTheFormBtn = true,
}) => {
  const { t } = useTranslation()
  const { brandWebsite } = useConfig()

  return (
    <div className={className}>
      <StyledModalTitle>
        <StyledFrownIcon />
        {t('errorModal.title')}
      </StyledModalTitle>

      <Modal.Content>
        {errorMessage && <Typography>{errorMessage}</Typography>}

        {showBackToTheFormBtn && (
          <StyledBackToTheForm onClick={onRequestClose}>
            {t('errorModal.backToTheForm')}
          </StyledBackToTheForm>
        )}

        <StyledNeedHelp>
          {t('errorModal.helpText')}
          <a
            href={`${brandWebsite}find-store`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('errorModal.storeLocator')}
          </a>
          .
        </StyledNeedHelp>
        <Divider />

        <StyledSecurityInfo>{t('errorModal.securityInfo')}</StyledSecurityInfo>
      </Modal.Content>
    </div>
  )
}

export const ErrorModal: React.FC<ErrorModalProps> = ({
  errorMessage,
  onRequestClose,
  error,
  showBackToTheFormBtn,
  ...props
}) => {
  const { country } = useConfig()

  if (!isCaOrUs(country) && error?.message === 'Unauthorized') {
    return <SessionExpired type="session" />
  }

  if (!isCaOrUs(country) && error?.message === 'Forbidden') {
    return <SessionExpired type="appointment" />
  }

  return (
    <Modal
      {...props}
      id="error-modal"
      showCloseButton
      onRequestClose={onRequestClose}
    >
      <ErrorModalContent
        errorMessage={errorMessage}
        showBackToTheFormBtn={showBackToTheFormBtn}
        onRequestClose={onRequestClose}
      />
    </Modal>
  )
}
